export default __webpack_public_path__ + "static/favicon-b338c9f7c3ecfa8a77f1b03bfb225a2d.ico";